/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Estimated_DamageInputs */

const en_case_field_estimated_damage = /** @type {(inputs: Case_Field_Estimated_DamageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated damage amount (USD)`)
};

const pt_br2_case_field_estimated_damage = /** @type {(inputs: Case_Field_Estimated_DamageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor estimado do dano (USD)`)
};

/**
* | output |
* | --- |
* | "Estimated damage amount (USD)" |
*
* @param {Case_Field_Estimated_DamageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_estimated_damage = /** @type {((inputs?: Case_Field_Estimated_DamageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Estimated_DamageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_estimated_damage(inputs)
	return pt_br2_case_field_estimated_damage(inputs)
});